import { render, staticRenderFns } from "./WhatWeDoScrollPin.vue?vue&type=template&id=17cdfb36"
import script from "./WhatWeDoScrollPin.vue?vue&type=script&lang=js"
export * from "./WhatWeDoScrollPin.vue?vue&type=script&lang=js"
import style0 from "./WhatWeDoScrollPin.vue?vue&type=style&index=0&id=17cdfb36&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports